// extracted by mini-css-extract-plugin
module.exports = {"fileInput":"FileInput_fileInput__2m5kp","label":"FileInput_label__H6BNt","selectedFiles":"FileInput_selectedFiles__1Aq9W"};